import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
        const response = await axios.get(`${apiUrl}/api/categories/${categoryId}`);
        setCategory(response.data);
        setLoading(false);
      } catch (err) {
        setError('Error loading category');
        setLoading(false);
      }
    };

    fetchCategory();
  }, [categoryId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!category) return <div>Category not found</div>;

  return (
    <div className="category-page">
      <h1>{category.name}</h1>
      <p>{category.description}</p>
      
      <div className="subcategories-grid">
        {category.subcategories.map((subcategory) => (
          <Link
            key={subcategory.slug}
            to={`/category/${categoryId}/${subcategory.slug}`}
            className="subcategory-card"
          >
            <h3>{subcategory.name}</h3>
            <p>{subcategory.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryPage; 